module.exports = __webpack_public_path__ + "img/msg-plaut-logo.a406e0f6.jpg";